import { AnimatePresence, motion } from "framer-motion";
import { useViewStore } from "../store/view-store";
import { slideVariants } from "../lib/slideVariants";

import { CalendarPage } from "./pages/calendar-page";
import Loader from "./loader";
import { lazy, Suspense, useEffect } from "react";

// Seul le planning est dans le premier telechargement : c'est ce que la
// plupart des visiteurs voient. Les autres ecrans (et Stripe avec la
// reservation) arrivent quand on les ouvre.
const LoginPage = lazy(() =>
  import("./pages/login-page").then((m) => ({ default: m.LoginPage })),
);
const ProfilePage = lazy(() => import("./pages/profile/profile-page"));
const CheckoutPage = lazy(() => import("./pages/checkout-page"));
const ConfirmationPage = lazy(() => import("./pages/confirmation-page"));
const ForgotPassword = lazy(() => import("./pages/password"));
const PackagesPage = lazy(() => import("./pages/packages-page"));
const PrivateBookingPage = lazy(() => import("./pages/private-booking-page"));
const VideosPage = lazy(() => import("./pages/videos-page"));

export function WidgetContent() {
  const { current, direction } = useViewStore();

  // 👇 Auto-scroll to top on every view change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [current]);

  function renderView(view: string) {
    switch (view) {
      case "calendar":
        return <CalendarPage />;
      case "packages":
        return <PackagesPage />;
      case "login":
        return <LoginPage />;
      case "password":
        return <ForgotPassword />;
      case "profile":
        return <ProfilePage />;
      case "booking":
        return <CheckoutPage />;
      case "confirmation":
        return <ConfirmationPage />;
      case "private-booking":
        return <PrivateBookingPage />;
      case "videos":
      case "video":
      case "programme":
        return <VideosPage view={view} />;
      default:
        return null;
    }
  }

  return (
    <div className="relative w-full">
      <AnimatePresence initial={false} custom={direction} mode="wait">
        <motion.div
          key={current}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "tween", duration: 0.2 },
            opacity: { duration: 0.2 },
          }}
          onAnimationComplete={() => {
            const height = document.documentElement.scrollHeight;
            window.parent.postMessage(
              { type: "WIDGET_RESIZE", height: height + 20 },
              "*",
            );
          }}
          className="w-full"
        >
          <Suspense fallback={<Loader />}>{renderView(current)}</Suspense>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
